/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Employeepost200,
  GetApiV1Employeepost401,
  GetApiV1Employeepost500,
  GetApiV1EmployeepostQueryParams,
  GetApiV1EmployeepostQueryResponse,
} from "../../types/employeePostController/GetApiV1Employeepost.ts";
import { employeePostViewModelPaginatedResponseSchema } from "../employeePostViewModelPaginatedResponseSchema.ts";

export const getApiV1EmployeepostQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  filter: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1EmployeepostQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Employeepost200Schema = z.lazy(
  () => employeePostViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Employeepost200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Employeepost401Schema =
  z.any() as unknown as ToZod<GetApiV1Employeepost401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Employeepost500Schema =
  z.any() as unknown as ToZod<GetApiV1Employeepost500>;

export const getApiV1EmployeepostQueryResponseSchema = z.lazy(
  () => getApiV1Employeepost200Schema,
) as unknown as ToZod<GetApiV1EmployeepostQueryResponse>;
